import { render, staticRenderFns } from "./SetupTopView.vue?vue&type=template&id=0dc9b3da&scoped=true"
import script from "./SetupTopView.vue?vue&type=script&lang=ts"
export * from "./SetupTopView.vue?vue&type=script&lang=ts"
import style0 from "./SetupTopView.vue?vue&type=style&index=0&id=0dc9b3da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc9b3da",
  null
  
)

export default component.exports